import React, { useEffect, useState } from "react";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import IconRoundButton from "../../CommonButtons/IconRoundButton";
import SVGComponent from "../../SVGComponent";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";
import ICONS from "../../../../assets/Icons";
import TEXT from "../../../../utils/globalText";
import EditCommonPopup from "../CommonEditPopup";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 */
/**
 * @typedef {("white" | "black")} HoverOption
 */
/**
 * @param {Object} props
 * @param {string} props.headerTitle - Main title text to display at the top of popup
 * @param {string} [props.headerFontWeight] - Font weight for header title eg:- "normal", "semibold", "bold"
 * @param {string} [props.headerFontColor] - Text color class for header eg:- "text-primary", "text-secondary", "failed"
 * @param {string} [props.textSize] - Font size class for header eg:- "font-sm", "font-md", "font-lg"
 * @param {string} [props.headerWithIcon] - Icon/SVG image path to display next to header title
 * @param {string} [props.secondHeaderTitle] - Optional secondary header text below main title
 * @param {string} [props.secondHeaderFontWeight] - Font weight for secondary header eg:- "normal", "semibold"
 * @param {string} [props.secondHeaderFontColor] - Text color class for secondary header eg:- "text-primary"
 * @param {string} [props.secondHeaderTextSize] - Font size class for secondary header eg:- "font-sm"
 * @param {string} [props.subtext] - Subtitle/description text below headers
 * @param {string} [props.closeIconBgColor] - Background color when close button is enabled (CSS variable)
 * @param {boolean} [props.closeisLoading] - Show loading state on close button (true/false)
 * @param {OnClickEventHandler} [props.closehandleFunction] - Handle function when close button is clicked
 * @param {string} [props.closeiconImg] - Icon/SVG image path for close button
 * @param {HoverOption} [props.closehoverOption] - Hover effect option for close button eg:- "white" or "black"
 * @param {BtnType} [props.closebtnType] - Button type for close button eg:- "button" or "submit"
 * @param {boolean} [props.closeisDisabled] - Disable close button (true/false)
 * @param {string} [props.closeIconDisableBgColor] - Background color when close button is disabled (CSS variable)
 * @param {React.RefObject} [props.closebuttonRef] - Button ref for close button (optional)
 * @param {string} [props.closeimgColor] - Icon color for close button (CSS variable)
 * @param {string} [props.switcherInitialActiveTab] - Initial active tab key for SwitcherTabs
 * @param {Array<Object>} [props.switcherTabs] - Array of tab objects for SwitcherTabs. Each tab object should have: { label: string, key: string, handler?: function, isDisabled?: boolean }
 * @param {boolean} [props.switcherIsDisabled] - Disable SwitcherTabs (true/false)
 * @param {("single" | "dual")} [props.switcherType] - SwitcherTabs display type: "single" for single-line, "dual" for multi-line
 * @param {string} [props.switcherTabBgColor] - Background color for SwitcherTabs (CSS variable)
 * @param {string} [props.alertSubtext] - Alert subtext/description text
 * @param {string} [props.alertHeaderOne] - First alert header text
 * @param {string} [props.alertHeaderTwo] - Second alert header text
 * @param {string} [props.alertHeadertextcolor] - Text color class for alert header
 * @param {string} [props.alertHeadertweight] - Font weight for alert header eg:- "normal", "semibold", "bold"
 * @param {string} [props.alertHeaderTextSize] - Font size class for alert header
 * @param {string} [props.alertSubtextTextSize] - Font size class for alert subtext
 * @param {string} [props.alertSubtexttextcolor] - Text color class for alert subtext
 * @param {string} [props.alertSubtextHeader] - Alert subtext header text
 * @param {string} [props.alertSubTextHeaderColor] - Text color class for alert subtext header
 * @param {boolean} [props.isneedalertSecondHeader] - Show/hide second alert header (true/false)
 * @param {boolean} [props.isneedsecondHeaderTitle] - Show/hide second header title (true/false)
 * @param {string} [props.btnOneText] - Text to display on first button (left button). If not provided, button will not be rendered.
 * @param {BtnType} [props.btnOneType] - Button type for first button eg:- "button" or "submit"
 * @param {OnClickEventHandler} [props.btnOnehandleFunction] - Handle function when first button is clicked
 * @param {boolean} [props.btnOneisDisabled] - Disable first button (true/false)
 * @param {string} [props.btnOneenabledTextColor] - Text color when first button is enabled (CSS variable)
 * @param {string} [props.btnOnedisabledTextColor] - Text color when first button is disabled (CSS variable, defaults to enabledTextColor)
 * @param {string} [props.btnOneenabledBgColor] - Background color when first button is enabled (CSS variable)
 * @param {string} [props.btnOnedisabledBgColor] - Background color when first button is disabled (CSS variable)
 * @param {string} [props.btnOneOutLineColor] - Border/outline color for first button (CSS variable)
 * @param {boolean} [props.btnOneFullWidthRequired] - Make first button full width (true/false)
 * @param {HoverOption} [props.btnOnehoverOption] - Hover effect option for first button eg:- "white" or "black"
 * @param {boolean} [props.btnOneisLoading] - Show loading state on first button (true/false)
 * @param {React.RefObject} [props.btnOnebuttonRef] - Button ref for first button (optional)
 * @param {boolean} [props.btnOneInActiveVariantNeeded] - Use inactive variant for first button (true/false)
 * @param {boolean} [props.btnOneIsLoaderNeeded] - Show loader on first button (true/false)
 * @param {string} [props.btnTwoText] - Text to display on second button (right button). If not provided, button will not be rendered.
 * @param {BtnType} [props.btnTwoType] - Button type for second button eg:- "button" or "submit"
 * @param {OnClickEventHandler} [props.btnTwohandleFunction] - Handle function when second button is clicked
 * @param {boolean} [props.btnTwoisDisabled] - Disable second button (true/false)
 * @param {string} [props.btnTwoenabledTextColor] - Text color when second button is enabled (CSS variable)
 * @param {string} [props.btnTwodisabledTextColor] - Text color when second button is disabled (CSS variable, defaults to enabledTextColor)
 * @param {string} [props.btnTwoenabledBgColor] - Background color when second button is enabled (CSS variable)
 * @param {string} [props.btnTwodisabledBgColor] - Background color when second button is disabled (CSS variable)
 * @param {string} [props.btnTwoOutLineColor] - Border/outline color for second button (CSS variable)
 * @param {boolean} [props.btnTwoFullWidthRequired] - Make second button full width (true/false)
 * @param {HoverOption} [props.btnTwohoverOption] - Hover effect option for second button eg:- "white" or "black"
 * @param {boolean} [props.btnTwoisLoading] - Show loading state on second button (true/false)
 * @param {React.RefObject} [props.btnTwobuttonRef] - Button ref for second button (optional)
 * @param {boolean} [props.btnTwoInActiveVariantNeeded] - Use inactive variant for second button (true/false)
 * @param {boolean} [props.btnTwoIsLoaderNeeded] - Show loader on second button (true/false)
 * @returns {JSX.Element}
 */
const SmallAnnocementsPopup = ({
  headerTitle,
  headerWithIcon,
  subtext,

  switcherInitialActiveTab,
  switcherTabs,
  switcherIsDisabled,
  switcherType,
  switcherTabBgColor,
  headericonimgColor,
  closeCallback,
  announcementData,
  setSelectedTxnData,
  chipsArray,
  hasModService,
  hasCreateService,
  hasCreateInternalService,
  viewAllReminderService,
  buttonText,
  bottomButtonText,
  closeIconBgColor,
  primaryBtnBgColor,
}) => {
  const [animate, setAnimate] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);

  useEffect(() => {
    if (!showModal) {
      setSelectedChipIndex(null);
    }
  }, [showModal]);

  const safeChipsArray = Array.isArray(chipsArray) ? chipsArray : [];

  const txnTypeChipsArray = safeChipsArray.map((chip, index) => ({
    ...chip,
    selected: selectedChipIndex === index,
    hoverOption: chip.hoverOption || "blue",
    onClick: () => {
      if (!chip.disabled) {
        setSelectedChipIndex(index);
      }
    },
  }));

  const handleTxnTypeModalClose = () => {
    setSelectedChipIndex(null);
    setShowModal(false);
  };

  const handleTxnTypeConfirm = () => {
    if (selectedChipIndex === null) return;
    safeChipsArray[selectedChipIndex]?.onClick?.();
    setSelectedChipIndex(null);
    setShowModal(false);
  };

  const toSentenceCase = (text = "") =>
    text.charAt(GlobalConfiguration?.lengthCheckZero).toUpperCase() +
    text.slice(GlobalConfiguration?.lengthCheckOne).toLowerCase();

  const needsFullStop = (text = "") => !text.trim().endsWith(".");

  return (
    <>
      <div onClick={(e) => e.stopPropagation()} />
      {showModal && (
        <div className="fixed top-left-base left-left-base w-screen h-screen z-z-index-max bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            headerTitle="Select transaction type"
            subtext="Only transactions for the selected option will be displayed"
            chipsArray={txnTypeChipsArray}
            btnOneBtnType="button"
            btnOneHandleFunction={handleTxnTypeModalClose}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Confirm"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleTxnTypeConfirm}
            btnTwoIsDisabled={selectedChipIndex === null}
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoHoverOption="black"
            defaultHeight={selectedChipIndex}
          />
        </div>
      )}

      <div className="fixed left-left-base top-top-base w-width-full h-height-full z-z-index-modal ">
        <div className="flex Qmd:flex-col w-width-full h-height-full justify-center items-center Qmd:gap-gap-xl">
          <div
            className={` w-standard-largePopup-width fixed Qmd:w-small-popup-width ${announcementData?.length > GlobalConfiguration.lengthCheckZero ? "" : "h-reminder-popup-no-data-height"}   max-h-alert-popup-height-1 xxl:max-h-alert-popup-height-2 tall:max-h-alert-popup-height-2    flex flex-col  bg-primary-bg rounded-border-radius-md animate-none ${animate ? "Qmd:animate-slideInFromLeft" : "Qmd:animate-slideInFromRight"} overflow-y-hidden overflow-x-hidden`}
          >
            <div className=" flex flex-1 flex-col h-full overflow-hidden ">
              {/* upper */}
              <div className=" flex flex-col p-padding-md ">
                <div className="flex justify-between gap-gap-md ">
                  <div className="flex flex-col items-start gap-1">
                    <div className=" flex gap-gap-sm">
                      <SVGComponent
                        color={"var(--emphasis)"}
                        height="var(--icon-md)"
                        width="var(--icon-md)"
                        url={ICONS?.ANNOUNCEMENT_GREY}
                        alt="CustomIcon"
                      />
                      <p
                        className={`text-text-primary  text-font-md font-semibold`}
                      >
                        {toSentenceCase(headerTitle)}
                      </p>
                    </div>
                    <div>
                      {subtext && (
                        <p
                          className={`  text-font-xs text-text-secondary   font-font-normal `}
                        >
                          {linkIdentifier(subtext)}
                          {needsFullStop(subtext) && <span>.</span>}
                        </p>
                      )}
                    </div>
                  </div>

                  <IconRoundButton
                    enabledBgColor={closeIconBgColor}
                    isLoading={false}
                    handleFunction={() => {
                      setAnimate(true);
                      setTimeout(() => {
                        closeCallback();
                      }, IntervalConfiguration.intervalSemiMid);
                    }}
                    icon={ICONS?.CLOSE}
                    title={TEXT?.CLOSE}
                    hoverOption="white"
                  />
                </div>
              </div>

              {/* {switcherTabs && switcherTabs.length > 0 && (
            <div className="w-full  pt-padding-md ">
              <SwitcherTabs
                initialActiveTab={switcherInitialActiveTab}
                tabs={switcherTabs}
                isDisabled={switcherIsDisabled}
                type={switcherType}
                swicherTabBgColor={switcherTabBgColor}
              />
            </div>
          )} */}

              {announcementData?.length >
              GlobalConfiguration.lengthCheckZero ? (
                <>
                  <div className="w-full h-full   px-padding-md flex flex-col gap-gap-md mb-margin-md flex-1 overflow-y-scroll">
                    {announcementData?.map((announcement) => {
                      return (
                        <div className="rounded-border-radius-sm bg-primary-card px-padding-md py-padding-sm   ">
                          <div className="flex flex-col gap-gap-md overflow-x-hidden">
                            <div className="flex flex-col gap-1 items-start">
                              <p className="text-text-primary font-semibold text-font-sm">
                                {announcement?.title}
                              </p>
                              <p className="text-font-xs text-text-secondary">
                                {announcement?.description}
                              </p>
                            </div>
                            {/* date and button */}
                            <div className="flex flex-row items-center  justify-between gap-2">
                              <div className="flex flex-row gap-3 items-center">
                                <SVGComponent
                                  url={ICONS.CALENDER}
                                  height="var(--icon-md)"
                                  width="var(--icon-md)"
                                  color={"var(--text-primary)"}
                                />
                                <p className="text-text-primary font-semibold text-font-xs">
                                  {announcement?.announcement_date}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div
                  className={`flex flex-col items-center  mt-margin-lg gap-3 justify-center m-auto  max-w-reminder-popup-no-data-width `}
                >
                  <img
                    src={ICONS?.NO_DATA_FOUND}
                    alt="No data found"
                    className="w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
                  />

                  <p className="text-text-primary text-font-xs text-center ">
                    There are no new updates.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmallAnnocementsPopup;
